import { render, staticRenderFns } from "./proType.vue?vue&type=template&id=0c09e52b&scoped=true"
import script from "./proType.vue?vue&type=script&lang=js"
export * from "./proType.vue?vue&type=script&lang=js"
import style0 from "./proType.vue?vue&type=style&index=0&id=0c09e52b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c09e52b",
  null
  
)

export default component.exports